export const OrderNegotiationTypes = Object.freeze({
  EmNegociacaoComposicaoCarga: 10,
  AnteciparColetaPedido: 18,
  AtrasarColetaPedido: 19,
  RenegociacaoDePedidoParaAtenderDemanda: 47,
  InboundDelivery: 57,
  OrderInTransit: 63
});
